module.exports = __webpack_public_path__ + "RobotoRegular.7ad6ece6fef9d2f63e06.svg";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoRegular.svg
// module id = ../../../../../src/fonts/RobotoRegular.svg
// module chunks = 3